import React from "react";
import { arrayOf, object, string } from "prop-types";
import { Box, Chip } from "@mui/material";
import { platformConfig } from "shared/platform/config";

const PlatformChips = ({ chips, style = {} }) => {
  return (
    <Box display="flex" style={style}>
      {chips.map((chip, i) => {
        const tool = platformConfig.tools.find((t) => t.name === chip);
        return (
          <Chip
            key={i}
            label={chip}
            sx={{
              "&:focus": {
                boxShadow: (theme) => `0 0 0 0.2rem ${theme.palette.secondary.main}`,
              },
              marginRight: "5px",
              marginTop: "5px",
              backgroundColor: "white",
            }}
            variant="outlined"
            clickable
            component="a"
            href={(tool && tool.href) || ""}
          />
        );
      })}
    </Box>
  );
};

PlatformChips.propTypes = {
  chips: arrayOf(string).isRequired,
  style: object,
};

export default PlatformChips;
